import axios from 'axios';
import Cookies from 'js-cookie';

export const getGPSHistory = (params, signal) => axios.get(
    `${import.meta.env.VITE_BASEURL}/get/live-tracking/history`,
    { params, signal, timeout: 60000, headers: { Authorization: `Bearer ${Cookies.get('auth_token')}` } }
).then(response => response.data);
